import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithFilemaker_1 from '../../../../../libraries/Images/createAConnectionWithFilemaker_1.png';
import createAConnectionWithFilemaker_2 from '../../../../../libraries/Images/createAConnectionWithFilemaker_2.png';
import createAConnectionWithFilemaker_3 from '../../../../../libraries/Images/createAConnectionWithFilemaker_3.png';
import createAConnectionWithFilemaker_4 from '../../../../../libraries/Images/createAConnectionWithFilemaker_4.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithfilemaker">
                1.&nbsp;{translate('createaconnectionwithfilemaker')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "Filemaker" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_2} width="75%" />
            </Zoom>
            <p>Sau khi bạn nhấp vào "Filemaker", vui lòng nhập các giá trị cần thiết rồi nhấp nút OK để hoàn tất.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ Filemaker sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_4} width="50%"/>
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong Filemaker.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);